/* eslint-disable complexity */
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { KngGridPager, KngLoaderState, Notification, NotificationList, NotificationState, ResponseNotification } from './definitions';
import { NotificationService } from './notification.service';
import { Icons, Notifications } from '../../services/shared/shared-enums';
import { EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { SharedService } from '../../services/shared/shared.service';
import { PagerService } from 'kinetic-angular';
import { SharedApiService } from '../../services/shared/shared-api-call.service';


@Component({
	selector: 'tmhna-portal-notifications',
	templateUrl: './template/notifications.component.html',
	styleUrls: ['./template/notifications.component.scss']
})
export class NotificationComponent implements Notification, OnInit, OnDestroy
{
	private readonly subscriptions: Subscription = new Subscription();
	@Input() set state(value: NotificationState)
	{
		this.service.updateState(value);
		this.pager = this.pagerService.getPager(this.state.tabs[0].pageInfo.totalCount, this.currentPage, this.state.tabs[0].pageInfo.pageSize);
	}
	get state(): NotificationState
	{
		return this.service.state;
	}
	noMessageIcon = Icons.noMessage;
	loaderState: KngLoaderState = {
		imagePath: Icons.loaderWhite
	};
	tabName: string = '';
	notifications = Notifications;
	startIndexBuffer: number = 0;
	endIndexBuffer: number = 0;
	pageNumber: number = 1;
	totalCount: number = 0;
	currentPage: number = 1;
	unreadValue: string = Notifications.unread;
	all: string = Notifications.all;
	update: string = Notifications.update;
	action: string = Notifications.action;
	offer: string = Notifications.offer;
	previousTab: number = 0;
	pager: KngGridPager = {
		totalPages: 1,
		currentPage: this.currentPage,
		endIndex: 0,
		endPage: 1,
		pageSize: 7,
		startIndex: 0,
		startPage: 1,
		totalItems: this.state.tabs[0].data.length
	};
	notificationList: NotificationList = {
		portalUserID: this.sharedService.getUserId(),
		notificationType: 'all',
		contactGRID: '',
		roles: [],
		locations: []
	};
	@Output() stateChanged: EventEmitter<NotificationState> = new EventEmitter<NotificationState>();
	flag: boolean = false;
	selectedIndex: number = 0;
	constructor( public service: NotificationService, private readonly pagerService: PagerService, public sharedService: SharedService, public sharedApiService: SharedApiService,
		@Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef
	) { }
	ngOnInit(): void
	{
		this.initSubscriptions();
		this.service.getNotificationLabels();
		this.service.getNotificationData(this.notificationList);
		this.service.pushAnalyticsEvent({
			event: 'pageView',
			page: {
				name: 'notifications',
				type: 'notifications'
			}
		});
		this.service.updateCurrentPageChanged.subscribe((isChanged: boolean) =>
		{
			if (isChanged)
			{
				this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : this.currentPage;
				this.startIndexBuffer = this.pager.startIndex;
				this.endIndexBuffer = this.pager.endIndex;
				this.setPage(this.currentPage);
				this.service.updateCurrentPageState(false);
			}
		});
	}
	ngOnDestroy(): void
	{
		this.destroySubscriptions();
	}
	private initSubscriptions(): void
	{
		const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
			(next: NotificationState) => this.stateChanged.emit(next)
		);
		this.subscriptions.add(stateChangeSubs);
	}
	private destroySubscriptions(): void
	{
		this.subscriptions.unsubscribe();
	}
	activateTab(index: number, tab: string)
	{
		this.previousTab = this.selectedIndex;
		this.pageNumber = 1;
		this.pager.currentPage = 1;
		this.pager = this.pagerService.getPager(this.state.tabs[index].data.length, this.pager.currentPage, this.state.tabs[index].pageInfo.pageSize);
		this.tabName = tab;
		switch (this.tabName)
		{
		  case Notifications.offer:
	
		 !this.service.isRaymond &&( this.state.tabs[3].data = this.service.notificationOrignalDataOffer);
		  break;

		  case Notifications.action:
	
		  this.state.tabs[2].data = this.service.notificationOrignalDataAction;
		  break;

		  case Notifications.update:
		  this.state.tabs[1].data = this.service.notificationOrignalDataUpdate;
		  break;

		  default:
		  this.state.tabs[0].data = this.service.notificationOrignalData;
		}
		this.flag = true;
		this.service.selectedIndex = index;
		this.selectedIndex = index;
		this.setPage(this.pageNumber, true);
	}
	setPage(e: number, firstTab?: boolean)
	{
		this.pageNumber = e;
		this.pager.currentPage = e;
		this.currentPage = e;
		this.service.currentPage = e;
		this.pager = this.pagerService.getPager(this.state.tabs[this.selectedIndex].data.length, e, this.state.tabs[this.selectedIndex].pageInfo.pageSize);
		this.service.totalPages = this.pager.totalPages;
		if (!firstTab)
		{
			this.notificationCheck(this.tabName);
		}
		else
		{
			switch (this.previousTab)
			{

			case 3:
				if(!this.service.isRaymond)
				{
					this.notificationCheck(Notifications.offer);
					this.state.tabs[1].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataUpdate);
					this.state.tabs[2].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataAction);
		        this.state.tabs[0].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalData);
				}
				break;
			case 1:
				this.notificationCheck(Notifications.update);
				this.state.tabs[0].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalData);
				this.state.tabs[2].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataAction);
				!this.service.isRaymond &&(this.state.tabs[3].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataOffer));
				break;
			case 2:
				this.notificationCheck(Notifications.action);
				this.state.tabs[1].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataUpdate);
				this.state.tabs[0].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalData);
				!this.service.isRaymond &&(this.state.tabs[3].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataOffer));
				break;
			default:
				this.notificationCheck(Notifications.all);
				(this.state.tabs[1].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataUpdate));
				 (this.state.tabs[2].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataAction));
				 !this.service.isRaymond &&(this.state.tabs[3].unreadCountData = this.checkUnreadNotifications(this.service.notificationOrignalDataOffer));
			}
		}
	}
	getNotificationId(id: string)
	{
		if (id)
		{
			this.service.deleteNotification(id);
		}
	}
	markAllRead() 
	{
		const unreadNotifications = this.service.notificationOrignalData.filter(data => data.status === Notifications.unread);
		this.service.updateNotification(unreadNotifications, true);
	}
	pageNameCheck(notificationData: ResponseNotification[])
	{
		if ((this.currentPage > 1 || this.startIndexBuffer > 0 || this.flag) && notificationData.length > 0)
		{
			notificationData = this.startIndexBufferFunction(notificationData);	
		}
		const count = this.countUpdate(notificationData);
		this.startIndexBuffer = this.pager.startIndex;
		this.endIndexBuffer = this.pager.endIndex;
		this.readStatusUpdate(notificationData);
		return {
			notificationData: notificationData, count: count
		};
	}
	readStatusUpdate(notificationData: ResponseNotification[])
	{
		const unreadNotification = [];
		for (let i = this.startIndexBuffer; i < this.endIndexBuffer + 1; i++) 
		{
			if (notificationData[i]?.status.toLocaleLowerCase() === this.unreadValue) 
			{
				unreadNotification.push(notificationData[i]);
			}
		}
		if(unreadNotification.length > 0)
		{
			this.service.updateNotification(unreadNotification);
		}
	}
	countUpdate(notificationData: ResponseNotification[])
	{
		const unreadCount = this.checkUnreadNotifications(this.service.notificationOrignalData);
		this.sharedApiService.updatedUnreadNotificationState = unreadCount > 0;
		return notificationData.filter(t => t.status !== 'read').length;

	}
	startIndexBufferFunction(notificationData: ResponseNotification[])
	{
		for (let i = this.startIndexBuffer; i < this.endIndexBuffer + 1 ; i++)
		{
			if (notificationData[i]?.status.toLocaleLowerCase() === this.unreadValue) 
			{
				notificationData[i].status = 'read';
				this.state.tabs[0].unreadCountData = 0;
				this.state.tabs[1].unreadCountData = 0;
				this.state.tabs[2].unreadCountData = 0;
				!this.service.isRaymond &&(	this.state.tabs[3].unreadCountData = 0);
			}
		} 
		return notificationData;
	}
	checkUnreadNotifications(notificationData: ResponseNotification[])
	{
		return notificationData.filter(t => t.status !== 'read').length;
	}
	notificationCheck(tab: string) 
	{
		let notificationData: ResponseNotification[] = [];
		switch (tab) 
		{
		case Notifications.offer:
		{
			notificationData = this.service.notificationOrignalDataOffer;
			const countOffer: { notificationData: ResponseNotification[]; count: number } = this.pageNameCheck(notificationData);
			this.state.tabs[3].unreadCountData = countOffer.count;
			this.state.tabs[3].data = countOffer.notificationData;
			break;
		}
		case Notifications.action:
		{
			notificationData = this.service.notificationOrignalDataAction;
			const countAction: { notificationData: ResponseNotification[]; count: number } = this.pageNameCheck(notificationData);
			this.state.tabs[2].unreadCountData = countAction.count;
			this.state.tabs[2].data = countAction.notificationData;
			break;
		}
		case Notifications.update:
		{
			notificationData = this.service.notificationOrignalDataUpdate;
			const countUpdate: { notificationData: ResponseNotification[]; count: number } = this.pageNameCheck(notificationData);
			this.state.tabs[1].unreadCountData = countUpdate.count;
			this.state.tabs[1].data = countUpdate.notificationData;
			break;

		}
		default:
		{
			notificationData = this.service.notificationOrignalData;
			const countAll: { notificationData: ResponseNotification[]; count: number } = this.pageNameCheck(notificationData);
			this.state.tabs[0].unreadCountData = countAll.count;
			this.state.tabs[0].data = countAll.notificationData;
		}
		}
	}
}
